module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[98]219.9eb5d7b.woff2";